import React, { Component } from "react";
import PropTypes from 'prop-types';
// @material-ui/core components
import { withStyles } from "@material-ui/styles";
import Modal from "@material-ui/core/Modal";
import DialogContent from '@material-ui/core/DialogContent';
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Table from "components/Table/Table.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import Button from "components/CustomButtons/Button.js";
// services
import userService from "services/user.service";
// management imports 
import CadastrarAlunos from "./Cadastrar";
import EditarAlunos from "./Editar";
import MatricularAlunos from "./Matricular";
import DeletarAlunos from "./Deletar";
// util
import Notifications from "views/Notifications/Notifications";

const styles = theme => ({
 	cardCategoryWhite: {
		"&,& a,& a:hover,& a:focus": {
			color: "rgba(255,255,255,.62)",
			margin: "0",
			fontSize: "14px",
			marginTop: "0",
			marginBottom: "0"
		},
		"& a,& a:hover,& a:focus": {
			color: "#FFFFFF"
		}
  	},
	cardTitleWhite: {
		color: "#FFFFFF",
		marginTop: "0px",
		minHeight: "auto",
		fontWeight: "300",
		fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
		marginBottom: "3px",
		textDecoration: "none",
		"& small": {
			color: "#777",
			fontSize: "65%",
			fontWeight: "400",
			lineHeight: "1"
		}
	}
});

class GerenciarAlunos extends Component {
    constructor(props) {
        super(props);
		this.state = {users: [], show: "", editUid: "", notification: {show: false, message: '', type: 'info'}};
		this.handleSearch();
    }

    handleOpenCreate = () => {
      	this.setState({ show: "create" });
	};

	handleOpenEdit = (uid) => {
		this.setState({ show: "edit", editUid: uid });
	};
	  
	handleOpenRegister = (uid) => {
		this.setState({ show: "register", editUid: uid });
	};
	
	handleFreeDeviceLogin = (uid) => {
		userService.freeDevice(uid)
		.then(res => this.showNotification('Dispositivo liberado para login com sucesso!', 'success'))
        .catch(err => this.showNotification('Ocorreu um erro ao liberar dispositivo do aluno! ' + err, 'danger'))
	};
	  
	handleOpenDelete = (uid) => {
		this.setState({ show: "delete", editUid: uid });
	};

	showNotification(message, type){
        this.setState({notification: {show: true, message: message, type: type}});
        setTimeout(() => {
        this.setState({notification: {show: false, message: '', type: 'info'}});
        }, 3000);
    }
	
	handleSearch() {
		userService.listAllUsers().then(users => {
			const tableUsers = []
		   	users.forEach(user => {
			  tableUsers.push([
					user.displayName, 
					user.email, 
					<Button color="primary" type="submit" round onClick={(event) => {this.handleOpenRegister(user.uid)}}>Gerenciar Livros</Button>,
					<Button color="primary" type="submit" round onClick={(event) => {this.handleFreeDeviceLogin(user.uid)}}>Liberar Dispositivo</Button>,
					<Button color="primary" type="submit" round onClick={(event) => {this.handleOpenEdit(user.uid)}}>Editar</Button>,
					<Button color="primary" type="submit" round onClick={(event) => {this.handleOpenDelete(user.uid)}}>Excluir</Button>
			  ])
			})
			this.setState({users: tableUsers})
	  	})
	}

    render() {
        const { classes } = this.props;
        return (
          	<GridContainer>
				<GridItem xs={12} sm={12} md={12}>
					<Button color="primary" type="submit" round onClick={this.handleOpenCreate}>Cadastrar Aluno</Button>
				</GridItem>
            	<GridItem xs={12} sm={12} md={12}>
              		<Card>
						<CardHeader color="primary">
							<h4 className={classes.cardTitleWhite}>Lista de Alunos</h4>
							<p className={classes.cardCategoryWhite}>
								Lista para visualização e gerenciamento dos Alunos
							</p>
						</CardHeader>
                		<CardBody>
							<Table
								tableHeaderColor="primary"
								tableHead={["Nome", "Email", "Gerenciar Livros do Aluno", "Liberar Dispositivo para Login", "Editar", "Excluir"]}
								tableData={this.state.users}
							/>
                		</CardBody>
              		</Card>
            	</GridItem>
				<Modal open={this.state.show === 'create'} onClose={() => {this.setState({show: ""}); this.handleSearch()}} aria-labelledby="simple-modal-title" aria-describedby="simple-modal-description">
					<DialogContent>
						<CadastrarAlunos onClose={() => {this.setState({show: ""}); this.handleSearch()}}/>
					</DialogContent>
				</Modal>
				<Modal open={this.state.show === 'register'} onClose={() => {this.setState({show: ""})}} aria-labelledby="simple-modal-title" aria-describedby="simple-modal-description">
					<DialogContent>
						<MatricularAlunos uid={this.state.editUid} onClose={() => {this.setState({show: ""})}}/>
					</DialogContent>
				</Modal>
				<Modal open={this.state.show === 'edit'} onClose={() => {this.setState({show: ""}); this.handleSearch()}} aria-labelledby="simple-modal-title" aria-describedby="simple-modal-description">
					<DialogContent>
						<EditarAlunos uid={this.state.editUid} onClose={() => {this.setState({show: ""}); this.handleSearch()}}/>
					</DialogContent>
				</Modal>
				<Modal open={this.state.show === 'delete'} onClose={() => {this.setState({show: ""}); this.handleSearch()}} aria-labelledby="simple-modal-title" aria-describedby="simple-modal-description">
					<DialogContent>
						<DeletarAlunos uid={this.state.editUid} onClose={() => {this.setState({show: ""}); this.handleSearch()}} />
					</DialogContent>
				</Modal>
				{(this.state.notification.show === true) ? (<Notifications notification={this.state.notification} />) : null}
          	</GridContainer>
        );
    };
}

GerenciarAlunos.propTypes = {
    classes: PropTypes.object.isRequired,
};
  
export default withStyles(styles)(GerenciarAlunos);